import { render, staticRenderFns } from "./voiceOptions.vue?vue&type=template&id=08d705a8&scoped=true&lang=pug&"
import script from "./voiceOptions.vue?vue&type=script&lang=js&"
export * from "./voiceOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d705a8",
  null
  
)

export default component.exports